import { render } from "./BotGenAI.vue?vue&type=template&id=698cc779&scoped=true"
import script from "./BotGenAI.vue?vue&type=script&lang=js"
export * from "./BotGenAI.vue?vue&type=script&lang=js"

import "./BotGenAI.vue?vue&type=style&index=0&id=698cc779&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698cc779"]])

export default __exports__